import React, { memo, ReactNode } from 'react';

import { cn } from '../../lib/css/className/className';
import { TextProps } from '../TextGeneric/TextGeneric';
import { TextGenericWithSkin } from '../TextGeneric/TextGenericWithSkin';
import { SkinSize } from '../../lib/skin/getSizeSkin/generated/types';

import { ParagraphSize } from './types';
import { paragraphSizeToSkin } from './utils';

import './Paragraph.css';

const cls = cn('Paragraph');

export interface ParagraphProps extends Omit<TextProps, 'textSize' | 'caption' | 'as' | 'bold'> {
    /**
     * Текст абзаца
     */
    children?: ReactNode;

    /**
     * Размер текста
     * @default m
     */
    size?: ParagraphSize;
}

/**
 * Компонент для создания параграфов
 */
export const Paragraph = memo<ParagraphProps>(function Paragraph({
    className,
    children,
    size = 'm',
    color = 'gray',
    ...props
}) {
    const skinSize: SkinSize = paragraphSizeToSkin[size];

    return (
        <TextGenericWithSkin
            {...props}
            className={cls({}, [className])}
            color={color}
            textSize={'current-main'}
            skinSize={skinSize}
            as="p"
        >
            {children}
        </TextGenericWithSkin>
    );
});
